import _ from 'lodash'

export function sortBy (array, sortKey, reverse) {
  array.sort((a, b) => {
    let aValue = _.get(a, sortKey)
    let bValue = _.get(b, sortKey)

    // Pousse les valeurs null à la fin
    if (_.isNil(aValue)) return 1
    if (_.isNil(bValue)) return -1

    if (reverse) {
      [aValue, bValue] = [bValue, aValue]
    }

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return aValue - bValue
    }

    return aValue.toString().localeCompare(bValue.toString())
  })

  return array
}
